import env from './env';

const onSigninCallback = (_user) => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

const oidcConfig = {
  authority: env('REACT_APP_OIDC_URL'),
  client_id: env('REACT_APP_OIDC_CLIENT_ID'),
  redirect_uri: env('REACT_APP_FRONTEND_URL') + '/auth-callback',
  post_logout_redirect_uri: env('REACT_APP_FRONTEND_URL') + '/auth-callback',
  onSigninCallback: onSigninCallback,
};

export default oidcConfig;
